export const PARTS = ({
  weekStart,
  weekEnd,
  partStatistic,
  oDataFilter,
  searchValue,
}: {
  weekStart: string;
  weekEnd: string;
  partStatistic: any;
  oDataFilter?: string;
  searchValue?: string;
}) => [
  {
    name: 'Modified this week',
    icon: {
      name: 'calendar',
      color: 'Gray/Light/2',
    },
    api: partStatistic,
    params: {
      oDataFilter: `ModifiedOn ge ${weekStart} and ModifiedOn lt ${weekEnd} ${oDataFilter}`,
      search: searchValue,
    },
  },
  {
    name: 'Created This Week',
    icon: {
      name: 'calendar',
      color: 'Gray/Light/2',
    },
    api: partStatistic,
    params: {
      oDataFilter: `CreatedOn ge ${weekStart} and CreatedOn lt ${weekEnd} ${oDataFilter}`,
      search: searchValue,
    },
    select: ['PartId'],
  },
];

export const PRODUCTION_ORDERS = ({
  productionOrdersStatistic,
  weekStart,
  weekEnd,
  nextWeekStart,
  nextWeekEnd,
  todayStartDate,
  timeNow,
  todayEndDate,
  oDataFilter,
  searchValue,
}: {
  productionOrdersStatistic: any;
  weekStart: string;
  weekEnd: string;
  nextWeekStart: string;
  nextWeekEnd: string;
  todayStartDate: string;
  timeNow: string;
  todayEndDate: string;
  oDataFilter?: string;
  searchValue?: string;
}) => [
  {
    name: 'Late',
    icon: {
      name: 'error',
      color: 'Label/Light/Warning',
    },
    api: productionOrdersStatistic,
    params: {
      oDataFilter: `IsActive eq true and (ProductionStartedOn eq null and ScheduledStartDate lt ${timeNow}) or (ProductionStartedOn ne null and ScheduledEndDate lt ${timeNow})`,
      search: searchValue,
    },
    select: ['ProductionOrderId'],
  },
  {
    name: 'This Week',
    icon: {
      name: 'calendar',
      color: 'Gray/Light/2',
    },
    api: productionOrdersStatistic,
    params: {
      oDataFilter: `ScheduledEndDate ge ${weekStart} and ScheduledStartDate lt ${weekEnd} ${oDataFilter}`,
      search: searchValue,
    },
    select: ['ProductionOrderId'],
  },
  {
    name: 'Next Week',
    icon: {
      name: 'calendar',
      color: 'Gray/Light/2',
    },
    api: productionOrdersStatistic,
    params: {
      oDataFilter: `ScheduledEndDate ge ${nextWeekStart} and ScheduledStartDate lt ${nextWeekEnd} ${oDataFilter}`,
      search: searchValue,
    },
    select: ['ProductionOrderId'],
  },
  {
    name: 'Unfinished',
    icon: {
      name: 'calendar',
      color: 'Gray/Light/2',
    },
    api: productionOrdersStatistic,
    params: {
      oDataFilter: `IsActive eq true${oDataFilter}`,
      search: searchValue,
    },
    select: ['ProductionOrderId'],
  },
  {
    name: 'Finished Today',
    icon: {
      name: 'finishFlag',
      color: 'NC-Color/Light/Comment',
    },
    api: productionOrdersStatistic,
    params: {
      oDataFilter: `ScheduledEndDate ge ${todayStartDate} and ScheduledEndDate lt ${todayEndDate} ${oDataFilter}`,
    },
    select: ['ProductionOrderId'],
  },
];

export const OPERATIONS = ({
  productionOperationsStatistic,
  weekStart,
  nextWeekStart,
  nextWeekEnd,
  timeNow,
  oDataFilter,
  searchValue,
}: {
  productionOperationsStatistic: any;
  weekStart: string;
  weekEnd: string;
  nextWeekStart: string;
  nextWeekEnd: string;
  todayStartDate: string;
  todayEndDate: string;
  timeNow: string;
  oDataFilter?: string;
  searchValue?: string;
}) => [
  {
    name: 'Late',
    icon: {
      name: 'error',
      color: 'Label/Light/Warning',
    },
    api: productionOperationsStatistic,
    params: {
      oDataFilter: `Status ne 'Finished' and ScheduleExceedsOn lt ${timeNow} ${oDataFilter}`,
      search: searchValue,
    },
    select: ['ProductionOrderId'],
    statStorageName: 'OPERATIONS_LATE',
    statContext: timeNow,
  },
  {
    name: 'Now - Weekend',
    icon: {
      name: 'calendar',
      color: 'Gray/Light/2',
    },
    api: productionOperationsStatistic,
    params: {
      oDataFilter: `Status ne 'Finished' and ScheduleExceedsOn ge ${timeNow} and ScheduleExceedsOn lt ${nextWeekStart} ${oDataFilter}`,
      search: searchValue,
    },
    select: ['ProductionOrderId'],
    statStorageName: 'OPERATIONS_NOW',
    statContext: timeNow,
  },
  {
    name: 'Next Week',
    icon: {
      name: 'calendar',
      color: 'Gray/Light/2',
    },
    api: productionOperationsStatistic,
    params: {
      oDataFilter: `Status ne 'Finished' and ScheduleExceedsOn ge ${nextWeekStart} and ScheduleExceedsOn lt ${nextWeekEnd} ${oDataFilter}`,
      search: searchValue,
    },
    select: ['ProductionOrderId'],
    statStorageName: 'OPERATIONS_NEXT_WEEK',
    statContext: nextWeekStart,
  },
  {
    name: 'After Next Week',
    icon: {
      name: 'calendar',
      color: 'Gray/Light/2',
    },
    api: productionOperationsStatistic,
    params: {
      oDataFilter: `Status ne 'Finished' and ScheduleExceedsOn ge ${nextWeekEnd} ${oDataFilter}`,
      search: searchValue,
    },
    select: ['ProductionOrderId'],
    statStorageName: 'OPERATIONS_AFTER_NEXT_WEEK',
    statContext: nextWeekEnd,
  },
  {
    name: 'Finished This Week',
    icon: {
      name: 'finishFlag',
      color: 'NC-Color/Light/Comment',
    },
    params: {
      oDataFilter: `Status eq 'Finished' and ProductionEndedOn ge ${weekStart} and ProductionEndedOn lt ${nextWeekStart} ${
        oDataFilter ? oDataFilter.replace(/and Status ne 'Finished'/g, '') : ''
      }`.replace(/  /g, ' '),
    },
    select: ['ProductionOrderId'],
    api: productionOperationsStatistic,
    statContext: weekStart,
  },
];

export const PRODUCTION_BATCHES = ({
  facetsStorage,
  oDataFilter,
}: {
  facetsStorage: Record<string, any>;
  oDataFilter?: string;
  searchValue?: string;
}) => [
  {
    name: 'Unknown NC File',
    icon: {
      name: 'unknownLink',
      color: 'Label/Light/AlwaysDark Primary',
    },
    params: {
      oDataFilter: `NcFileStatus eq 'Unknown' ${oDataFilter}`,
    },
    value: facetsStorage.Unknown,
  },
  {
    name: 'Not Linked',
    icon: {
      name: 'ncFileLinked',
      color: 'Status/Light/Productive',
    },
    params: {
      oDataFilter: `LinkStatus eq 'PartialLink' ${oDataFilter}`,
    },
    value: facetsStorage.PartialLink,
  },
  {
    name: 'Single Link',
    icon: {
      name: 'linked',
      color: 'Status/Light/Productive',
    },
    params: {
      oDataFilter: `LinkStatus eq 'SingleLink' ${oDataFilter}`,
    },
    value: facetsStorage.SingleLink,
  },
  {
    name: 'Multi Link',
    icon: {
      name: 'multiLink',
      color: 'Status/Light/Productive',
    },
    params: {
      oDataFilter: `LinkStatus eq 'MultiLink' ${oDataFilter}`,
    },
    value: facetsStorage.MultiLink,
  },
];

export const PRODUCTION_BATCHES_WITHOUT_ERP = ({
  facetsStorage,
  oDataFilter,
}: {
  facetsStorage: Record<string, any>;
  oDataFilter?: string;
  searchValue?: string;
}) => [
  {
    name: 'Unknown NC File',
    icon: {
      name: 'notLinked',
      color: 'Label/Light/AlwaysDark Primary',
    },
    params: {
      oDataFilter: `NcFileStatus eq 'Unknown' ${oDataFilter}`,
    },
    value: facetsStorage.Unknown,
  },
  {
    name: 'Linked NC File',
    icon: {
      name: 'linked',
      color: 'Status/Light/Productive',
    },
    params: {
      oDataFilter: `NcFileStatus eq 'Linked' ${oDataFilter}`,
    },
    value: facetsStorage.Linked,
  },
];

export const NC_FILES = ({ facetsStorage, oDataFilter }: { facetsStorage: Record<string, any>; oDataFilter?: string }) => [
  {
    name: 'Unknown',
    icon: {
      name: 'unknown',
      color: 'Status/Light/Missing',
    },
    params: {
      oDataFilter: `NcFileStatus eq 'Unknown' ${oDataFilter}`,
    },
    value: facetsStorage.Unknown,
  },
  {
    name: 'Linked',
    icon: {
      name: 'linked',
      color: 'Status/Light/Productive',
    },
    params: {
      oDataFilter: `NcFileStatus eq 'Linked' ${oDataFilter}`,
    },

    value: facetsStorage.Linked,
  },
  {
    name: 'Change',
    icon: {
      name: 'change',
      color: 'Status/Light/Change',
    },
    params: {
      oDataFilter: `NcFileStatus eq 'Change' ${oDataFilter}`,
    },
    value: facetsStorage.Change,
  },
  {
    name: 'Setup',
    icon: {
      name: 'setup',
      color: 'Status/Light/Setup',
    },
    params: {
      oDataFilter: `NcFileStatus eq 'Setup' ${oDataFilter}`,
    },
    value: facetsStorage.Setup,
  },
  {
    name: 'Ignore',
    icon: {
      name: 'ignore',
      color: 'Status/Light/Not Productive',
    },
    params: {
      oDataFilter: `NcFileStatus eq 'Ignored' ${oDataFilter}`,
    },
    value: facetsStorage.Ignored,
  },
];

export const TOOLS = ({
  toolsStatistic,
  weekStart,
  weekEnd,
  oDataFilter,
  searchValue,
}: {
  toolsStatistic: any;
  weekStart: string;
  weekEnd: string;
  oDataFilter?: string;
  searchValue?: string;
}) => [
  {
    name: 'Modified this week',
    icon: {
      name: 'calendar',
      color: 'Gray/Light/2',
    },
    api: toolsStatistic,
    params: {
      oDataFilter: `ModifiedOn ge ${weekStart} and ModifiedOn lt ${weekEnd} ${oDataFilter}`,
      search: searchValue,
    },
  },
  {
    name: 'Created This Week',
    icon: {
      name: 'calendar',
      color: 'Gray/Light/2',
    },
    api: toolsStatistic,
    params: {
      oDataFilter: `CreatedOn ge ${weekStart} and CreatedOn lt ${weekEnd} ${oDataFilter}`,
      search: searchValue,
    },
    select: ['ToolId'],
  },
];

export const IMAGES_DOCUMENTS = ({
  oDataFilter,
  documentsStatistic,
  searchValue,
  weekStart,
  weekEnd,
}: {
  weekStart: string;
  weekEnd: string;
  oDataFilter?: string;
  documentsStatistic: any;
  searchValue?: string;
}) => [
  {
    name: 'Part Images',
    icon: {
      name: 'partImage',
      color: 'Label/Light/Tertiary',
    },
    params: {
      oDataFilter: `Tags/any (tag: tag eq 'Image') ${oDataFilter}`,
      search: searchValue,
    },
    api: documentsStatistic,
  },
  {
    name: '2D Drawings',
    icon: {
      name: 'twoDDrawing',
      color: 'Label/Light/Tertiary',
    },
    params: {
      oDataFilter: `Tags/any (tag: tag eq '2D Drawing') ${oDataFilter}`,
    },
    api: documentsStatistic,
  },
  {
    name: 'Created This Week',
    icon: {
      name: 'calendar',
      color: 'Label/Light/Tertiary',
    },
    params: {
      oDataFilter: `CreatedOn ge ${weekStart} and CreatedOn lt ${weekEnd} ${oDataFilter}`,
    },
    api: documentsStatistic,
  },
  {
    name: 'Not Attached',
    icon: {
      name: 'clipCross',
      color: 'Label/Light/Tertiary',
    },
    params: {
      oDataFilter: `not Links/any() ${oDataFilter}`,
    },
    api: documentsStatistic,
  },
];
